/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: ivrsActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Incoming Call Tools module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteIVR } from './api/ivrApi';

/**
 * Shared helpers for IVRs module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate an IVR in the form.
 * Pattern: /pbx/incoming-tools/ivr/new?duplicate={id}
 */
export const getIvrDuplicateUrl = (id: string | number): string =>
  `/pbx/incoming-tools/ivr/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given IVR id.
 */
export const navigateToIvrDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getIvrDuplicateUrl(id));
};

/**
 * Low-level API helper to delete an IVR by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteIvrById = async (id: string | number): Promise<void> => {
  await deleteIVR(id);
};



